import api from './api';

function validateCodeEntry(data) {
    return api
        .get(`/entries/validate-codes/?barcode=${data.barcode}&batchcode=${data.batchcode}`);
}

export default {
    validateCodeEntry
};